import React from "react";
import { Navbar } from "../components/Navbar";
import { PageHeader } from "../components/PageHeader";
import { ProjectGallery } from "../components/ProjectGallery";
import { CtaBanner } from "../components/CtaBanner";
import { Footer } from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";
import { productImages } from "../data/images";

export default function Projects() {
  const { t } = useLang();
  return (
    <main className="bg-[#F9F8F6] text-[#1A1A1A] font-body" data-testid="page-projects">
      <Navbar transparentOnHome={false} />
      <PageHeader
        eyebrow={t("gallery.eyebrow")}
        title={t("gallery.title")}
        subtitle={t("gallery.subtitle")}
        image={productImages.vinyl}
      />
      <ProjectGallery hideHeader />
      <CtaBanner variant="dark" />
      <Footer />
    </main>
  );
}
